"use client";

import _defineProperty from "/opt/buildhome/repo/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/buildhome/repo/gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["as", "ratio", "children"];
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import r from "react";
var d = "__wrap_b",
  f = "__wrap_o",
  m = typeof window == "undefined",
  p = m ? r.useEffect : r.useLayoutEffect,
  y = function y(o, n, e) {
    e = e || document.querySelector("[data-br=\"".concat(o, "\"]"));
    var s = e.parentElement,
      c = function c(_) {
        return e.style.maxWidth = _ + "px";
      };
    e.style.maxWidth = "";
    var t = s.clientWidth,
      i = s.clientHeight,
      a = t / 2 - .25,
      l = t + .5,
      u;
    if (t) {
      for (; a + 1 < l;) {
        u = Math.round((a + l) / 2), c(u), s.clientHeight === i ? l = u : a = u;
      }
      c(l * n + t * (1 - n));
    }
    e.__wrap_o || (e.__wrap_o = new ResizeObserver(function () {
      self.__wrap_b(0, +e.dataset.brr, e);
    })).observe(s);
  },
  v = y.toString(),
  b = function b(o) {
    var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    return r.createElement("script", {
      suppressHydrationWarning: !0,
      dangerouslySetInnerHTML: {
        __html: (o ? "" : "self.".concat(d, "=").concat(v, ";")) + n
      }
    });
  },
  E = r.createContext(!1),
  x = function x(_ref) {
    var o = _ref.children;
    return r.createElement(E.Provider, {
      value: !0
    }, b(!1), o);
  },
  R = function R(_ref2) {
    var _ref2$as = _ref2.as,
      o = _ref2$as === void 0 ? "span" : _ref2$as,
      _ref2$ratio = _ref2.ratio,
      n = _ref2$ratio === void 0 ? 1 : _ref2$ratio,
      e = _ref2.children,
      s = _objectWithoutProperties(_ref2, _excluded);
    var c = r.useId(),
      t = r.useRef(),
      i = r.useContext(E);
    return p(function () {
      t.current && (self[d] = y)(0, n, t.current);
    }, [e, n]), p(function () {
      return function () {
        if (!t.current) return;
        var a = t.current[f];
        !a || (a.disconnect(), delete t.current[f]);
      };
    }, []), process.env.NODE_ENV === "development" && e && !Array.isArray(e) && typeof e == "object" && "type" in e && typeof e.type == "string" && e.type !== "span" && console.warn("<Balancer> should not wrap <".concat(e.type, "> inside. Instead, it should directly wrap text or inline nodes.\n\nTry changing this:\n  <Balancer><").concat(e.type, ">content</").concat(e.type, "></Balancer>\nTo:\n  <").concat(e.type, "><Balancer>content</Balancer></").concat(e.type, ">")), r.createElement(r.Fragment, null, r.createElement(o, _objectSpread(_objectSpread({}, s), {}, {
      "data-br": c,
      "data-brr": n,
      ref: t,
      style: {
        display: "inline-block",
        verticalAlign: "top",
        textDecoration: "inherit"
      },
      suppressHydrationWarning: !0
    }), e), b(i, "self.".concat(d, "(\"").concat(c, "\",").concat(n, ")")));
  };
if (!m && process.env.NODE_ENV !== "production") {
  var o = document.querySelector("[data-next-hide-fouc]");
  if (o) {
    var n = function n(s) {
        var _iterator = _createForOfIteratorHelper(s),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var c = _step.value;
            for (var _i = 0, _Array$from = Array.from(c.removedNodes); _i < _Array$from.length; _i++) {
              var t = _Array$from[_i];
              if (t !== o) continue;
              e.disconnect();
              var i = document.querySelectorAll("[data-br]");
              for (var _i2 = 0, _Array$from2 = Array.from(i); _i2 < _Array$from2.length; _i2++) {
                var a = _Array$from2[_i2];
                self[d](0, +a.dataset.brr, a);
              }
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      },
      e = new MutationObserver(n);
    e.observe(document.head, {
      childList: !0
    });
  }
}
var S = R;
export { x as Provider, S as default };